<template>
    <dash
        icon="fa fa-users"
        titulo="EQUIPE DE APOIO"
        subTitulo="SGTEC"
        @click.native="$router.push({ name: 'Sgtec_Gerentes_Apoios' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
